<template lang="pug">
div(
    class="max-w-sm w-full shadow-lg rounded pointer-events-auto overflow-hidden border"
    :class="backgroundColorClass"
    @mouseenter="clearTimer"
    @mouseleave="resetTimer"
)
    div(class="p-4")
        div(class="flex items-start")
            div(class="shrink-0")
                SuccessIcon(v-if="type === 'SUCCESS'" class="h-6 w-6 fill-current text-success-dark")
                ErrorIcon(v-else-if="type === 'ERROR'" class="h-8 w-8 fill-current text-danger-dark")
                InfoIcon(v-else class="h-4 w-4 fill-current text-info")

            div(class="ml-3 w-0 flex-1")
                p(class="text-sm font-bold text-gray-darkest") {{ notification.title }}
                p(
                    v-if="notification.message"
                    class="mt-1 text-sm text-gray-darker"
                )
                    | {{ notification.message }}

            div(class="ml-4 shrink-0 flex")
                button(
                    @click="close"
                    class="rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none"
                )
                    span.sr-only Close
                    img(
                        src="@/assets/common/x.svg"
                        aria-label="close"
                        @click="close"
                        width="12"
                        height="12"
                        class="cursor-pointer w-3 h-3"
                        loading="lazy"
                    )

</template>

<script>
import InfoIcon from '@/assets/common/info?inline'
import SuccessIcon from '@/assets/common/checkmarkCircle?inline'
import ErrorIcon from '@/assets/common/errorIcon?inline'

export default {
    name: 'SimpleNotification',
    components: {
        InfoIcon,
        SuccessIcon,
        ErrorIcon,
    },
    props: {
        notification: {
            type: Object,
            default() {
                return {}
            },
        },
        message: {
            type: String,
            default: '',
        },
        duration: {
            type: Number,
            default: 10000,
        },
        type: {
            type: String,
            default: 'DEFAULT',
            validator: (value) => {
                return ['DEFAULT', 'SUCCESS', 'ERROR'].includes(value)
            },
        },
    },
    computed: {
        backgroundColorClass() {
            let typeClasses = 'bg-white'
            if (this.type === 'SUCCESS') typeClasses = 'bg-gray-lighter'
            if (this.type === 'ERROR') typeClasses = 'bg-danger-light'
            return typeClasses
        },
    },
    mounted() {
        this.resetTimer()
    },
    methods: {
        resetTimer() {
            this.timeout = setTimeout(() => {
                this.close()
            }, this.duration)
        },
        clearTimer() {
            if (this.timeout) clearTimeout(this.timeout)
        },
        close() {
            this.clearTimer()
            this.$emit('close')
        },
    },
}
</script>
